module.exports = __webpack_public_path__ + "fonts/NHaasGroteskTXPro-75Bd.3c5508c.ttf";